module.exports = __webpack_public_path__ + "img/step3.ef18b539.png";